export default "__VITE_ASSET__3dc6ff92__"